<div class="phone">
  <div class="container-fluid" *ngIf="!activeCaller">
    <div class="row">
      <div class="col-12">
        <h4>Phone contacts</h4>
      </div>
    </div>
    <div class="row mb-4" *ngFor="let recipient of recipientsContactList">
      <div class="col-7 d-flex align-items-center ut-calls-recipient-name">
        {{recipient.name}}
      </div>
      <div class="col-5">
        <mat-chip-listbox class="mat-chip-list-stacked">
          <mat-chip-option
            [color]="'primary'"
            (click)="makeCall(recipient, phone.number)"
            *ngFor="let phone of recipient.phoneNumbers">
            Call {{phone.type}} {{phone.number}}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    </div>
  </div>

  <div class="container-fluid" *ngIf="activeCaller">
    <div class="row">
      <div class="col-5">
        <h4>Calling</h4>
        <h2 class="mt-3 mb-3">{{activeCaller.name}}</h2>
        <p>{{activePhoneNumber}}</p>
        <button mat-icon-button class="end-call">
          <mat-icon (click)="endCall()">call_end</mat-icon>
        </button>
      </div>
      <div class="col-7">
        <fmc-privacy-dialog
            [borrower]="activeCaller.borrower"
            [appId]="appId"
            [entityType]="entityType">
        </fmc-privacy-dialog>
      </div>
    </div>
  </div>
</div>
